import axios from "axios";
import Vue from "vue";

const state = {
	_attachment_loading: 0,
	_attachmentpreview_loading: 0,
	attachment: {},
	attachment_options: {
		page: 1,
		itemsPerPage: 10,
		sortBy: ["created_at"],
		sortDesc: [true],
		search: "",
		model_type: null,
		model_id: null,
	},
	showAttachment: false,
	showAttachmentList: false,
	showCreateEditAttachment: false,
	showAddAttachment: false,
	source: null,
	progress: {
		total: 100,
		loaded: 0,
	},
	temporarySource: [],
	temporaryProgress: [],
	attachmentCategory: null,
	currentAttachmentModel: {},
	_uploadattachment_loading: 0,
	_attachment_downloading: 0,
	temporaryAttachment: [],
	currentAttachment: {},
	_omit_changes_attachment: ["thumbnail_link", "thumbnail_path"],
	readAttachmentInfoFromFile: false,
	showAttachmentProposedData: false,
	attachmentProposedData: {},
};

const getters = {
	attachment_loading: (state) => state._attachment_loading !== 0,
	attachmentpreview_loading: (state) => state._attachmentpreview_loading !== 0,
	getAttachment: (state) => state.attachment,
	getAttachmentOptions: (state) => state.attachment_options,
	showAttachment: (state) => state.showAttachment,
	showAttachmentList: (state) => state.showAttachmentList,
	showAddAttachment: (state) => state.showAddAttachment,
	showCreateEditAttachment: (state) => state.showCreateEditAttachment,
	getProgress: (state) => state.progress,
	getSource: (state) => state.source,
	getTemporaryProgress: (state) => state.temporaryProgress,
	getTemporarySource: (state) => state.temporarySource,
	getAttachmentCategory: (state) => state.attachmentCategory,
	isAdminCategory: (state) => state.attachmentCategory.toLowerCase().includes("admin"),
	getCurrentAttachmentModel: (state) => state.currentAttachmentModel,
	uploadattachment_loading: (state) => state._uploadattachment_loading != 0,
	attachment_downloading: (state) => state._attachment_downloading != 0,
	getTemporaryAttachment: (state) => state.temporaryAttachment,
	getCurrentAttachment: (state) => state.currentAttachment,
	getOmitChangesAttachment: (state) => state._omit_changes_attachment,
	readAttachmentInfoFromFile: (state) => state.readAttachmentInfoFromFile,
	showAttachmentProposedData: (state) => state.showAttachmentProposedData,
	getAttachmentProposedData: (state) => state.attachmentProposedData,
};

const actions = {
	handleAttachmentDeleted({ commit, dispatch, rootState }, attachment) {
		let temporaryAttachmentModel = {};
		let temporaryPaginatedList = {};
		let finalCommitAttachment = null;
		let finalCommitPaginated = null;
		switch (state.attachmentCategory) {
			case "incomedeclarations":
				temporaryAttachmentModel = rootState.incomedeclarations.currentIncomeDeclarations;
				temporaryPaginatedList = rootState.incomedeclarations.incomedeclarations;
				finalCommitAttachment = "setCurrentIncomeDeclarations";
				finalCommitPaginated = "setIncomeDeclarations";
				break;
			case "adminincomedeclarations":
				temporaryAttachmentModel = rootState.adminincomedeclarations.currentAdminIncomeDeclarations;
				temporaryPaginatedList = rootState.adminincomedeclarations.adminincomedeclarations;
				finalCommitAttachment = "setCurrentAdminIncomeDeclarations";
				finalCommitPaginated = "setAdminIncomeDeclarations";
				break;
			default:
				break;
		}
		if (temporaryAttachmentModel.attachments) {
			let $finded = temporaryAttachmentModel.attachments.findIndex((x) => x.id === parseInt(attachment.id));
			if ($finded != -1) {
				temporaryAttachmentModel.attachments.splice($finded, 1);
			}
			commit("setCurrentAttachmentModel", temporaryAttachmentModel);
			if (finalCommitAttachment) {
				commit(finalCommitAttachment, temporaryAttachmentModel);
			}
			if (temporaryPaginatedList.data) {
				let $finded = temporaryPaginatedList.data.findIndex((x) => x.id === parseInt(temporaryAttachmentModel.id));
				if ($finded != -1) {
					temporaryPaginatedList.data[$finded] = temporaryAttachmentModel;
				}
				if (finalCommitPaginated) {
					commit(finalCommitPaginated, temporaryPaginatedList);
				}
			}
		} else {
			if (temporaryPaginatedList.data) {
				temporaryPaginatedList.data.forEach((paginatedModel) => {
					if (paginatedModel.attachments) {
						let $finded = paginatedModel.attachments.findIndex((x) => x.id === parseInt(attachment.id));
						if ($finded != -1) {
							paginatedModel.attachments.splice($finded, 1);
						}
					}
				});
			}
		}
		if (rootState.user.tenant_config.settings.AttachmentsViewStyle == "table") {
			dispatch("fetchAttachment");
		}
	},
	handleAttachmentAddOrUpdate({ commit, dispatch, rootState }, attachment) {
		let temporaryAttachmentModel = {};
		let temporaryPaginatedList = {};
		let finalCommitAttachment = null;
		let finalCommitPaginated = null;
		switch (state.attachmentCategory) {
			case "incomedeclarations":
				temporaryAttachmentModel = rootState.incomedeclarations.currentIncomeDeclarations;
				temporaryPaginatedList = rootState.incomedeclarations.incomedeclarations;
				finalCommitAttachment = "setCurrentIncomeDeclarations";
				finalCommitPaginated = "setIncomeDeclarations";
				break;
			case "adminincomedeclarations":
				temporaryAttachmentModel = rootState.adminincomedeclarations.currentAdminIncomeDeclarations;
				temporaryPaginatedList = rootState.adminincomedeclarations.adminincomedeclarations;
				finalCommitAttachment = "setCurrentAdminIncomeDeclarations";
				finalCommitPaginated = "setAdminIncomeDeclarations";
				break;
			default:
				break;
		}
		if (!temporaryAttachmentModel.attachments) {
			temporaryAttachmentModel.attachments = [];
		}
		if (temporaryAttachmentModel.attachments) {
			let $finded = temporaryAttachmentModel.attachments.findIndex((x) => x.id === parseInt(attachment.id));
			if ($finded != -1) {
				temporaryAttachmentModel.attachments[$finded] = attachment;
			} else {
				temporaryAttachmentModel.attachments.push(attachment);
			}
			commit("setCurrentAttachmentModel", temporaryAttachmentModel);
			if (finalCommitAttachment) {
				commit(finalCommitAttachment, temporaryAttachmentModel);
			}
			if (temporaryPaginatedList.data) {
				let $finded = temporaryPaginatedList.data.findIndex((x) => x.id === parseInt(temporaryAttachmentModel.id));
				if ($finded != -1) {
					temporaryPaginatedList.data[$finded] = temporaryAttachmentModel;
				}
			}
		}
		if (rootState.user.tenant_config.settings.AttachmentsViewStyle == "table" && state.showAttachment) {
			if (!state.readAttachmentInfoFromFile) {
				dispatch("hideAction", "hideAddAttachment");
				dispatch("hideAction", "hideAttachment");
			}
			dispatch("fetchAttachment");
		}
	},
	deleteAttachment({ commit, dispatch, rootState }, id) {
		commit("START_ATTACHMENT_LOADING");
		let route = "/api/attachment/";
		if (getters.isAdminCategory) {
			route = "/api/admin/attachment/";
		}
		return new Promise((resolve, reject) => {
			axios
				.delete(route + id)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					if (res.data.object) {
						dispatch("handleAttachmentDeleted", res.data.object);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ATTACHMENT_LOADING");
				});
		});
	},
	createAttachment({ commit, dispatch }) {
		commit("START_ATTACHMENT_LOADING");
		let route = "/api/attachment/";
		if (getters.isAdminCategory) {
			route = "/api/admin/attachment/";
		}
		let data = _.cloneDeep(state.currentAttachment);
		if (data.extra_info) {
			Object.keys(data.extra_info).forEach((key) => {
				data["extra_" + key] = data.extra_info[key];
			});
		}
		return new Promise((resolve, reject) => {
			axios
				.put(route + state.currentAttachment.id, data)
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					if (res.data.object) {
						dispatch("handleAttachmentAddOrUpdate", res.data.object);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ATTACHMENT_LOADING");
				});
		});
	},
	uploadTemporaryAttachment({ commit, dispatch }, formData) {
		commit("START_UPLOADATTACHMENT_LOADING");
		const source = axios.CancelToken.source();
		commit("setTemporarySource", { index: formData.get("index"), source: source });
		commit("setTemporaryProgress", { index: formData.get("index"), progress: { total: 100, loaded: 0, errors: null, complete: false } });
		let computedroute = null;
		switch (state.attachmentCategory) {
			case "incomedeclarations":
				computedroute = state.attachmentCategory + "/";
				break;
			case "adminincomedeclarations":
				computedroute = "admin/incomedeclarations/";
				break;
			default:
				break;
		}
		return new Promise((resolve, reject) => {
			axios
				.post("/api/" + computedroute + state.currentAttachmentModel.id + "/attachment", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						commit("setTemporaryProgress", { index: formData.get("index"), progress: { total: e.total, loaded: e.loaded, errors: null, complete: false } });
					},
				})
				.then((res) => {
					commit("setTemporaryProgress", { index: formData.get("index"), progress: { total: 100, loaded: 100, errors: null, complete: true } });
					if (res.data.object) {
						dispatch("handleAttachmentAddOrUpdate", res.data.object);
					}
					resolve(res.data);
				})
				.catch((err) => {
					let errormessage = "Errore durante il caricamento";
					if (err.response.data) {
						if (err.response.data.errors) {
							let errarray = err.response.data.errors;
							if (errarray.attachment) {
								errormessage = errarray.attachment[0].replace("attachment", i18n.t("attachment.attachment"));
							}
						}
						if (err.response.data.errormessage) {
							errormessage = err.response.data.errormessage;
						}
					} else {
						errormessage = err.data.message;
					}
					commit("setTemporaryProgress", { index: formData.get("index"), progress: { total: 100, loaded: 100, errors: errormessage, complete: true } });
					reject(err);
				})
				.then(function () {
					commit("STOP_UPLOADATTACHMENT_LOADING");
				});
		});
	},
	uploadAttachment({ commit, dispatch }, formData) {
		commit("START_UPLOADATTACHMENT_LOADING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		let computedroute = null;
		switch (state.attachmentCategory) {
			case "incomedeclarations":
				computedroute = state.attachmentCategory + "/" + state.currentAttachmentModel.id + "/attachment";
				break;
			case "adminincomedeclarations":
				computedroute = "admin/incomedeclarations/" + state.currentAttachmentModel.id + "/attachment";
				break;
			default:
				break;
		}
		return new Promise((resolve, reject) => {
			axios
				.post("/api/" + computedroute, formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					dispatch("handleResponseMessage", res.data);
					if (res.data.object) {
						dispatch("handleAttachmentAddOrUpdate", res.data.object);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_UPLOADATTACHMENT_LOADING");
				});
		});
	},
	fetchAttachmentProposedData({ commit, dispatch }, id) {
		commit("START_ATTACHMENT_LOADING");
		axios
			.get("/api/attachment/" + id + "/proposed-data")
			.then((res) => {
				commit("setAttachmentProposedData", res.data);
				dispatch("showAction", "showAttachmentProposedData");
			})
			.catch((err) => {
				commit("handleError", err);
			})
			.then(() => {
				commit("STOP_ATTACHMENT_LOADING");
			});
	},
	setCurrentModelForAttachment({ commit, dispatch }, params) {
		if (!params.filecategory || !params.object) {
			commit("showSnackbar", {
				message: "Errore configurazione gestione allegati",
			});
		} else {
			let can_go_on = true;
			switch (params.filecategory) {
				case "incomedeclarations":
					commit("setCurrentIncomeDeclarations", _.cloneDeep(params.object));
					break;
				case "adminincomedeclarations":
					commit("setCurrentAdminIncomeDeclarations", _.cloneDeep(params.object));
					break;
				default:
					commit("showSnackbar", {
						message: "Categoria allegati non definita",
					});
					can_go_on = false;
					break;
			}
			if (can_go_on) {
				commit("setCurrentAttachmentModel", _.cloneDeep(params.object));
				commit("setAttachmentCategory", params.filecategory);
			} else {
				commit("setCurrentAttachmentModel", {});
				commit("setAttachmentCategory", null);
			}
			dispatch("hideAction", "hideAttachment");
			dispatch("hideAction", "hideAddAttachment");
			if (params.show) {
				commit("showAttachment");
			}
		}
	},
	fetchAttachment({ commit }) {
		commit("START_ATTACHMENT_LOADING");
		let route = "/api/attachment";
		let options = _.cloneDeep(state.attachment_options);
		if (getters.isAdminCategory) {
			route = "/api/admin/attachment";
			options.tenant_id = state.currentAttachmentModel.tenant_id;
		}
		axios
			.get(route, { params: options })
			.then((res) => {
				commit("setAttachment", res.data);
			})
			.catch((err) => {
				commit("handleError", err);
			})
			.then(() => {
				commit("STOP_ATTACHMENT_LOADING");
			});
	},
	loadAttachmentPreview({ commit }, id) {
		commit("START_ATTACHMENTPREVIEW_LOADING");
		let route = "/api/attachment/";
		if (getters.isAdminCategory) {
			route = "/api/admin/attachment/";
		}
		axios
			.get(route + id)
			.then((res) => {
				commit("setAttachmentPreview", res.data);
			})
			.catch((err) => {
				commit("handleError", err);
			})
			.then(() => {
				commit("STOP_ATTACHMENTPREVIEW_LOADING");
			});
	},
};

const mutations = {
	START_ATTACHMENT_LOADING(state) {
		state._attachment_loading++;
	},
	STOP_ATTACHMENT_LOADING(state) {
		state._attachment_loading--;
	},
	START_ATTACHMENTPREVIEW_LOADING(state) {
		state._attachmentpreview_loading++;
	},
	STOP_ATTACHMENTPREVIEW_LOADING(state) {
		state._attachmentpreview_loading--;
	},
	setAttachment(state, value) {
		Vue.set(state, "attachment", value);
	},
	setAttachmentPreview(state, obj) {
		state.currentAttachment.thumbnail_link = obj.thumbnail_link;
		state.currentAttachment = JSON.parse(JSON.stringify(state.currentAttachment));
		if (state.currentAttachmentModel.attachments) {
			let $finded = state.currentAttachmentModel.attachments.findIndex((attachment) => attachment.id === parseInt(obj.id));
			if ($finded != -1) {
				state.currentAttachmentModel.attachments[$finded] = obj;
				state.currentAttachmentModel = JSON.parse(JSON.stringify(state.currentAttachmentModel));
			}
		}
	},
	setAttachmentOptions(state, value) {
		Vue.set(state, "attachment_options", value);
	},
	showAttachment(state) {
		state.showAttachment = true;
	},
	hideAttachment(state) {
		state.showAttachment = false;
	},
	showAttachmentList(state) {
		state.showAttachmentList = true;
	},
	hideAttachmentList(state) {
		state.showAttachmentList = false;
	},
	showCreateEditAttachment(state) {
		state.showCreateEditAttachment = true;
	},
	hideCreateEditAttachment(state) {
		state.showCreateEditAttachment = false;
	},
	showAddAttachment(state) {
		state.showAddAttachment = true;
	},
	hideAddAttachment(state) {
		state.showAddAttachment = false;
	},
	setSource(state, value) {
		Vue.set(state, "source", value);
	},
	setProgress(state, value) {
		Vue.set(state, "progress", value);
	},
	setTemporarySource(state, value) {
		state.temporarySource[value.index] = value.source;
		state.temporarySource = JSON.parse(JSON.stringify(state.temporarySource));
	},
	setTemporaryProgress(state, value) {
		state.temporaryProgress[value.index] = value.progress;
		state.temporaryProgress = JSON.parse(JSON.stringify(state.temporaryProgress));
	},
	resetTemporaryAttachment() {
		Vue.set(state, "temporaryProgress", []), Vue.set(state, "temporarySource", []);
	},
	setAttachmentCategory(state, value) {
		Vue.set(state, "attachmentCategory", value);
	},
	setCurrentAttachmentModel(state, value) {
		Vue.set(state, "currentAttachmentModel", value);
	},
	START_UPLOADATTACHMENT_LOADING(state) {
		state._uploadattachment_loading++;
	},
	STOP_UPLOADATTACHMENT_LOADING(state) {
		state._uploadattachment_loading--;
	},
	setTemporaryAttachment(state, value) {
		Vue.set(state, "temporaryAttachment", value);
	},
	setCurrentAttachment(state, value) {
		Vue.set(state, "currentAttachment", value);
	},
	setReadAttachmentInfoFromFile(state, value) {
		Vue.set(state, "readAttachmentInfoFromFile", value);
	},
	setAttachmentProposedData(state, value) {
		Vue.set(state, "attachmentProposedData", value);
	},
	showAttachmentProposedData(state) {
		state.showAttachmentProposedData = true;
	},
	hideAttachmentProposedData(state) {
		state.showAttachmentProposedData = false;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
